import React from "react";
import { EventFixture, PageType } from '../FixtureVerbose/EventFixture';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {CLEAR_DISPLAYED_FIXTURE, getOneFixtureAsync, LOADING, SET_WIDGET_ID} from "../../store/spirs/actions";
import {StoreType} from "../../store/spirs/types";
import {FixtureElement} from "../../models/api/codegen/code";

type matchRouteParams = {
    fixtureId?: string | undefined;
};

export const ShowFullFixture: React.FC<{page: PageType}> = ({page}) => {

    const dispatch = useDispatch();
    const params = useParams<matchRouteParams>();
    const playerId = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);
    const getFixture = (fixtureId: string) => {
        dispatch(getOneFixtureAsync.request({
            id: Number.parseInt(fixtureId),
            player: playerId
        }))
    }
    React.useEffect(() => {
        dispatch(LOADING());
        const fixtureId = params.fixtureId;
        if (fixtureId !== undefined) {
            getFixture(fixtureId);
            const interval = setInterval(() => getFixture(fixtureId), 5000);
            return () => {
                clearInterval(interval);
                dispatch(SET_WIDGET_ID({widgetId: undefined}));
                dispatch(CLEAR_DISPLAYED_FIXTURE({} as FixtureElement));
            }
        } else {
            console.log('there is no fixtureId passed at URL path');
        }
    }, [params.fixtureId]);

    return (<EventFixture page={page}/>)
}
